import axios from 'axios';
import { pushNotificationMessage } from './pushNotificationMessage';
import { siteUrl } from '../../config';
import { getShortPushNotification } from './getShortPushNotification';

export async function sendNotifications(
  type,
  requestContent,
  userId,
  userType,
  lang,
) {
  try {
    let content = {};
    console.log({
      type,
      requestContent,
      userId,
      userType,
      lang,
    }, "!!!!!!!!!!!!!!!!!!!!!!!!!!");

    if (type !== 'notification') {
      const { title, message } = await pushNotificationMessage(
        type,
        requestContent,
        lang,
      );
      console.log("-----------1111111111111111");

      const trimContent = await getShortPushNotification(message);
      content = requestContent;
      content.title = title;
      content.message = trimContent || message;
    } else {
      content = requestContent;
    }
    console.log({ content }, "2222222222222222222222");

    const response = await axios.post(`${siteUrl}/push-notification`, {
      content,
      userId,
      userType
    }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });
    
    console.log({ response }, "======================");

    const { status, errorMessage } = await response?.data;
    console.log({ status, errorMessage }, "33333333333333333333");


    return  {
      status,
      errorMessage,
    };
  } catch (error) {
    console.log('error', error);
  }
}

export default sendNotifications;
